import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { Card, theme, Typography } from 'antd';
import { useTranslation } from '@features/localization';
import { PAGE_KEYS } from '@constants';

const { useToken } = theme;

export function WagonCard({ data }) {
  const { t } = useTranslation();
  const { token } = useToken();

  if (!data) return null;

  return (
    <Card style={{ marginBottom: '1rem' }} bodyStyle={{ padding: '1rem' }}>
      <div
        style={{
          display: 'grid',
          gap: '1rem',
          gridTemplateColumns: 'repeat(6, 0.5fr)',
          gridTemplateRows: 'repeat(2, 0.5fr)',
        }}
      >
        <div>
          <Typography.Title level={5}>{t('wagons.fields.shopName')}</Typography.Title>
          <Typography.Text style={{ fontSize: '1rem', fontWeight: 600, color: token.colorPrimary }}>
            <Link to={`/${PAGE_KEYS.CLIENTS}/${data.shop.value}`} target='blank'>
              {data.shop.label}
            </Link>
          </Typography.Text>
        </div>
        <div>
          <Typography.Title level={5}>{t('wagons.fields.order')}</Typography.Title>
          <Typography.Text style={{ fontSize: '1rem' }}>{data.order.label}</Typography.Text>
        </div>
        <div>
          <Typography.Title level={5}>{t('wagons.fields.from')}</Typography.Title>
          <Typography.Text style={{ fontSize: '1rem' }}>
            {data.orderInfo?.stationFrom?.name || '—'}
          </Typography.Text>
        </div>
        <div>
          <Typography.Title level={5}>{t('wagons.fields.to')}</Typography.Title>
          <Typography.Text style={{ fontSize: '1rem' }}>
            {data.orderInfo?.stationTo?.name || '—'}
          </Typography.Text>
        </div>
        <div>
          <Typography.Title level={5}>{t('wagons.fields.nhm')}</Typography.Title>
          <Typography.Text style={{ fontSize: '1rem' }}>
            {data.orderInfo?.nhm || '—'}
          </Typography.Text>
        </div>
        <div>
          <Typography.Title level={5}>{t('wagons.fields.recipient')}</Typography.Title>
          <Typography.Text style={{ fontSize: '1rem' }}>
            {data.orderInfo.recipient?.name || '—'}
          </Typography.Text>
        </div>

        <div>
          <Typography.Title level={5}>{t('wagons.fields.number')}</Typography.Title>
          <Typography.Text style={{ fontSize: '1rem', fontWeight: 600, color: token.colorPrimary }}>
            <Link to={`/${PAGE_KEYS.TRACKING_PLACE}/${data.number}`} target='blank'>
              {data.number}
            </Link>
          </Typography.Text>
        </div>
        <div>
          <Typography.Title level={5}>{t('wagons.fields.sendDate')}</Typography.Title>
          <Typography.Text style={{ fontSize: '1rem' }}>
            {dayjs(data.sendDate).format('DD.MM.YYYY') || '—'}
          </Typography.Text>
        </div>
        <div>
          <Typography.Title level={5}>{t('wagons.fields.weight')}</Typography.Title>
          <Typography.Text style={{ fontSize: '1rem' }}>{data.weight || '—'}</Typography.Text>
        </div>
      </div>
    </Card>
  );
}

WagonCard.propTypes = {
  data: PropTypes.object,
};

WagonCard.defaultProps = {
  data: null,
};
